// Quem pode alterar o e-mail de destino da transportadora (#426).
// O banco é quem barra (trigger em lubpress_transportadoras); isto só evita
// oferecer na tela um campo que daria erro ao salvar.
export function podeEditarEmailTransportadora(cargo) {
  return cargo === "admin" || cargo === "gestor";
}
